import script from "./HeuresServicesForm.vue?vue&type=script&setup=true&lang=js"
export * from "./HeuresServicesForm.vue?vue&type=script&setup=true&lang=js"

import "./HeuresServicesForm.vue?vue&type=style&index=0&id=54a3a8d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54a3a8d0"]])

export default __exports__